import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // 1. Import hook
import { Menu, Users, PhoneCall, GraduationCap, Wallet, CalendarDays, Bell, BarChart3, ShieldAlert, ChevronDown, User, LogOut, X, Download, Contact, Contact2, PersonStanding, Book, Pen, Sliders, MarsIcon, ShieldCogCorner, LucideIndianRupee, TextSelect, TimelineIcon, NotepadTextIcon, VideoIcon, Calendar1Icon, DownloadIcon,  } from 'lucide-react';
import StaffAccessControl from './StaffAccessControl';
import CRMEnquiryManagement from './CRMEnquiryManagement';
import StudentManagement from './StudentManagement';
import CourseManagement from './CourseManagement';
import FeeManagement from './FeeManagement';
import ExamProjectUpdates from './ExamProjectUpdates';
import PushNotifications from './PushNotifications';
import Announcements from './Announcements';
import AdminDownloads from './Downloads';
import ContactCenter from './ContactCenter';
import StudentEnquiries from './StudentEnquiries';
import BookManagement from './BookManagement';
import ExamManagement from './ExamManagement';
import HeroSliderManagement from './HeroSliderManagement';
import ResultManagement from './ResultManagement';
import AppWelcomeSliders from './AppWelcomeSliders';
import PaymentMethodManagement from './PaymentMethodManagement';
import ModelPapersManagement from './ModelPapersManagement';
import ExamApplicationsList from './ExamApplicationsList';
import CiaAcknowledgementsList from './CiaAcknowledgementsList';
import NoticeManagement from './NoticeManagement';
import LiveClassesManagement from './LiveClassesManagement';
import AdmissionImportantDates from './AdmissionImportantDates';
import ProspectusManagement from './ProspectusManagement';

export default function AdminDashboard() {
  const navigate = useNavigate(); // 2. Initialize router link
  
  // 3. Read live user data straight from your secure storage cache
  const currentUser = JSON.parse(sessionStorage.getItem('userSession')) || {
    name: "Staff Member",
    role: "Admin"
  };

  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [activeModule, setActiveModule] = useState('');
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);

  // 4. Create the session wipe handler
  const handleSystemLogout = () => {
    sessionStorage.clear(); // Wipes out all active access credentials instantly
    navigate('/login', { replace: true }); // Locks them out and returns to login gate
  };


  const [staffList, setStaffList] = useState([
    { id: 1, name: "Anand Kumar", email: "anand@met.com", mobile: "9876543210", role: "counsellor", gender: "Male" },
    { id: 2, name: "Priya Raj", email: "priya@met.com", mobile: "8765432109", role: "accounts", gender: "Female" }
  ]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;


//   const allModulesMaster = [
//     { id: 'crm', name: 'CRM & Enquiries', icon: PhoneCall },
//     { id: 'students', name: 'Student Management', icon: Users },
//     { id: 'courses', name: 'Course Management', icon: GraduationCap },
//     { id: 'fees', name: 'Fee Management', icon: Wallet },
//     { id: 'exams', name: 'Exams & Projects', icon: CalendarDays },
//     { id: 'notifications', name: 'Push Notifications', icon: Bell },
//     { id: 'analytics', name: 'Reports & Analytics', icon: BarChart3 },
//     { id: 'access', name: 'Staff Access Control', icon: ShieldAlert },
//   ];

  const allModulesMaster = [
    { id: 'crm', name: 'CRM & Enquiries', icon: PhoneCall },
    { id: 'students', name: 'Student Management', icon: Users },
    
    { id: 'courses', name: 'Course Management', icon: GraduationCap },
    { id: 'fees', name: 'Fee Management', icon: Wallet },
    { id: 'exams', name: 'Exams & Projects', icon: CalendarDays },
          { id: 'eApplications', name: 'Exam Applications', icon:TimelineIcon },  
                 { id: 'CiaAck', name: 'Cia Acknowledgements', icon:TimelineIcon },  
       { id: 'ModelPapers', name: 'Model Papers', icon:TextSelect },  
    { id: 'notifications', name: 'Push Notifications', icon: Bell },
    { id: 'analytics', name: 'Reports & Analytics', icon: BarChart3 },
    { id: 'access', name: 'Staff Access Control', icon: ShieldAlert },
     { id: 'announcements', name: 'Announcements', icon: Bell},
     { id: 'downloads', name: 'Downloads', icon: Download},
      { id: 'contact', name: 'Contact Center', icon: Contact2},
       { id: 'studente', name: 'StudentEnquiries', icon: PersonStanding},
       { id: 'books', name: 'Books', icon: Book},
      //  { id: 'examss', name: 'Exam Management', icon:Pen },   
       { id: 'sliders', name: 'Hero Sliders', icon:Sliders },    
      //  { id: 'results', name: 'Results', icon:ShieldCogCorner },   
     { id: 'welcome', name: 'App Welcome Sliders ', icon:ShieldCogCorner },  
          { id: 'Notice', name: 'App Notice ', icon:NotepadTextIcon},  
             { id: 'liveClasses', name: 'Live Classes', icon:VideoIcon},  
                 { id: 'admImpDates', name: 'Admission Important Dates', icon:Calendar1Icon},         
                     { id: 'prospectus', name: 'Prospectus Management', icon:DownloadIcon},         
       { id: 'payment', name: 'Payment Details', icon:LucideIndianRupee },  
       
            
  ];

  const allowedModules = allModulesMaster.filter(mod => currentUser.permissions[mod.id] === true || currentUser.permissions[mod.id] === 1);

  useEffect(() => {
    const handleOutsideClick = () => setProfileDropdownOpen(false);
    window.addEventListener('click', handleOutsideClick);
    return () => window.removeEventListener('click', handleOutsideClick);
  }, []);

const getMobileLeftStyle = () => {
  if (window.innerWidth <= 768) {
    return {
      position: 'fixed',
      top: 0,
      left: 0,
      height: '100vh',
      transform: isMobileOpen
        ? 'translateX(0)'
        : 'translateX(-100%)',
    };
  }
  return {};
};
  return (
    <div style={styles.dashboardRoot}>
      
      {/* ========================================================= */}
      {/* SIDEBAR NAVIGATION LAYOUT MODULE                         */}
      {/* ========================================================= */}
      
      {/* Mobile Drawer Backdrop Layer */}
      {isMobileOpen && (
        <div style={styles.mobileOverlay} onClick={() => setIsMobileOpen(false)} />
      )}

      <aside style={{
        ...styles.sidebar,
        ...(isSidebarExpanded ? styles.sidebarExpanded : styles.sidebarCollapsed),
        ...getMobileLeftStyle() // Absolute JavaScript control fixes the hidden mobile sidebar bug
      }}>
        {/* Sidebar Header Section */}
        <div style={styles.sidebarHeader}>
          <div style={styles.logoBox}>EL</div>
          {(isSidebarExpanded || isMobileOpen) && <span style={styles.logoText}>EDULEARNER</span>}
          {isMobileOpen && (
            <button onClick={() => setIsMobileOpen(false)} style={styles.closeMobileBtn}>
              <X size={18} color="#fff" />
            </button>
          )}
        </div>

        {/* Floating Module Items Navigation Loop */}
        <nav style={styles.navContainer}>
       {allowedModules.map((mod) => {
            const IconComponent = mod.icon;
            const isActive = activeModule === mod.id;
            return (
              <button
                key={mod.id}
                onClick={() => {
                  setActiveModule(mod.id); 
                  setIsMobileOpen(false); 
                }}
                style={{
                  ...styles.navItem,
                  ...(isActive ? styles.navItemActive : {}),
                  ...(!isSidebarExpanded && !isMobileOpen ? styles.navItemCentered : {})
                }}
                title={mod.name}
              >
                <div style={styles.iconWrapper}>
                  <IconComponent size={18} style={isActive ? styles.iconActive : styles.iconInactive} />
                </div>
                {(isSidebarExpanded || isMobileOpen) && <span style={styles.navText}>{mod.name}</span>}
                {isActive && (isSidebarExpanded || isMobileOpen) && <div style={styles.activeIndicator} />}
              </button>
            );
          })}
        </nav>
      </aside>

      {/* ========================================================= */}
      {/* CORE FRAME CONTENT WRAPPER LAYOUT                        */}
      {/* ========================================================= */}
      <div style={styles.mainWrapper}>
        
        {/* Header Control Bar */}
        <header style={styles.headerBar}>
          <div style={styles.headerLeft}>
            <button 
              onClick={(e) => {
                e.stopPropagation();
                if (window.innerWidth <= 768) {
                  setIsMobileOpen(!isMobileOpen); 
                } else {
                  setIsSidebarExpanded(!isSidebarExpanded);
                }
              }} 
              style={styles.hamburgerBtn}
            >
              <Menu size={20} color="#e30504" />
            </button>
            <span style={styles.appName} className="responsive-app-name">EDULEARNER</span>
          </div>

          {/* User Status Profile Module */}
          <div 
            style={styles.profileContainer} 
            onClick={(e) => {
              e.stopPropagation();
              setProfileDropdownOpen(!profileDropdownOpen);
            }}
          >
            <div style={styles.avatarBox}>
              <User size={14} color="#459bf2" />
            </div>
            <div style={styles.profileMeta} className="desktop-only-meta">
              <span style={styles.userName}>{currentUser.name}</span>
              <ChevronDown size={12} color="rgba(255,255,255,0.4)" />
            </div>

            {/* Float Dropdown Context Card Menu */}
            {profileDropdownOpen && (
              <div style={styles.dropdownMenu}>
                <div style={styles.dropdownHeader}>
                  <p style={styles.dpName}>{currentUser.name}</p>
                  <p style={styles.dpRole}>{currentUser.role}</p>
                </div>
                <hr style={styles.divider} />
                <button style={styles.dropdownItem}>
                  <User size={14} style={{ marginRight: '10px' }} />
                  My Profile
                </button>
                <button onClick={handleSystemLogout} style={{ ...styles.dropdownItem, color: '#e30504' }}>
                  <LogOut size={14} style={{ marginRight: '10px' }} />
                  Logout Session
                </button>
              </div>
            )}
          </div>
        </header>

     
{/* WORKSPACE VIEWS SURFACE PORT */}
        <main style={styles.contentDock}>
          <div style={styles.viewCard}>
            
            {/* 2. LEAN AND CLEAN DYNAMIC ROUTING INNER ROUTER CONDITIONAL LINKS */}
            {activeModule === 'access' ? (
              <StaffAccessControl /> 
            ) : activeModule === 'crm' ? (
              <CRMEnquiryManagement /> /* ➕ ADDED: Live link to your education CRM layout module */
            ) :activeModule === 'students'?(
              <StudentManagement/>
            ) :activeModule === 'courses'?(
              <CourseManagement/>
            ) :activeModule === 'fees'? (
              <FeeManagement/>
            ): activeModule === 'exams' ? (
      <ExamProjectUpdates />
    ):activeModule ==='notifications'?(
      <PushNotifications/>
    ):activeModule ==="announcements"?(
      <Announcements/>
    ):activeModule === "downloads"?(
   <AdminDownloads/>
    ) :activeModule ==='contact'?
(
   <ContactCenter/>
    ) :activeModule ==='studente'?
(
   <StudentEnquiries/>
    ) 
     :activeModule ==='books'?
(
   <BookManagement/>
    )    :activeModule ==='examss'?
(
   <ExamManagement/>
    )    :activeModule ==='sliders'?
(
   <HeroSliderManagement/>
    )     :activeModule ==='results'?
(
   <ResultManagement/> 
    )     :activeModule ==='welcome'?
(
   <AppWelcomeSliders/> 
    )    :activeModule ==='payment'?
(
   <PaymentMethodManagement/> 
    )   :activeModule ==='ModelPapers'?
(
   <ModelPapersManagement/> 
    )    :activeModule ==='eApplications'?
(
   <ExamApplicationsList/> 
    )    :activeModule ==='CiaAck'?
(
   <CiaAcknowledgementsList/> 
    )    :activeModule ==='Notice'?
(
   <NoticeManagement/> 
    )    :activeModule ==='liveClasses'?
(
   <LiveClassesManagement/> 
    )   :activeModule ==='admImpDates'?
(
   <AdmissionImportantDates/> 
    )   :activeModule ==='prospectus'?
(
   <ProspectusManagement/> 
    )   
 
            
            
            
            : (
              <div>
                <h2 style={styles.moduleTitle}>{allModulesMaster.find(m => m.id === activeModule)?.name}</h2>
                <p style={styles.modulePlaceholder}>Workspace successfully active based on user access control matrix rules.</p>
              </div>
            )}

          </div>
        </main>
      </div>

      {/* Clean Global CSS Responsiveness Rules (Completely stripped conflicting aside targets) */}
{/* Global CSS Responsiveness & Light Framework Fixes */}
      <style dangerouslySetInnerHTML={{__html: `
        html, body {
          margin: 0;
          padding: 0;
          width: 100%;
          overflow-x: hidden;
          background-color: #f1f5f9; /* Premium light surface gray fallback */
        }
        @media (max-width: 768px) {
          .desktop-only-meta {
            display: none !important;
          }
          .responsive-app-name {
            font-size: 16px !important;
          }
          .responsive-module-title {
            font-size: 20px !important;
          }
          .responsive-text {
            font-size: 13px !important;
          }
        }
      `}} />
    </div>
  );
}

const styles = {
  dashboardRoot: {
    background: '#f4f7fe', /* Soft premium light canvas color */
 height: '100vh',
    maxHeight: '100vh',
    width: '100%',
    display: 'flex',
    position: 'relative',
    boxSizing: 'border-box',
    overflow: 'hidden'
  },
  mobileOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(15, 23, 42, 0.2)', 
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    zIndex: 999, 
  },
  
  // =========================================================
  // 🕶️ SIDEBAR MODULE - PRESERVED DARK EXTRAORDINARY DESIGN
  // =========================================================
  sidebar: {
    background: '#060b17', /* Dark Sidebar background preserved */
    borderRight: '1px solid rgba(255, 255, 255, 0.05)',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    
    top: 0,
    zIndex: 1000, 
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '20px 0 40px rgba(0,0,0,0.4)',
  },
  sidebarExpanded: {
    width: '300px',
    minWidth: '280px',
  },
  sidebarCollapsed: {
    width: '80px',
    minWidth: '80px',
  },
  sidebarHeader: {
    padding: '0 20px',
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    height: '70px', 
    minHeight: '70px',
    boxSizing: 'border-box',
  },
  logoBox: {
    width: '32px',
    height: '32px',
    background: 'linear-gradient(135deg, #e30504 0%, #a80302 100%)',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontWeight: '700',
    fontSize: '15px',
    boxShadow: '0 4px 12px rgba(227, 5, 4, 0.3)',
  },
  logoText: {
    color: '#ffffff',
    fontSize: '16px',
    fontWeight: '600',
    letterSpacing: '-0.2px',
  },
  closeMobileBtn: {
    marginLeft: 'auto',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  navContainer: {
    padding: '24px 12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px', 
    flex: 1,
    overflowY: 'auto',
  },
  navItem: {
    width: '100%',
    padding: '12px 14px',
    background: 'rgba(255, 255, 255, 0.01)',
    border: '1px solid rgba(255, 255, 255, 0.03)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'relative',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
    boxSizing: 'border-box',
    marginBottom: '4px', 
  },
  navItemCentered: {
    justifyContent: 'center',
    padding: '12px 0',
  },
  navItemActive: {
    background: 'linear-gradient(90deg, rgba(69, 155, 242, 0.1) 0%, rgba(69, 155, 242, 0.02) 100%)',
    borderColor: '#e30504',
    boxShadow: '0 8px 20px rgba(69, 155, 242, 0.15)', 
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '20px',
  },
  navText: {
    color: 'rgba(255, 255, 255, 0.65)',
    fontSize: '13.5px',
    fontWeight: '500',
    marginLeft: '12px',
    whiteSpace: 'nowrap',
  },
  iconActive: {
    color: '#e30504',
  },
  iconInactive: {
    color: 'rgba(255, 255, 255, 0.35)',
  },
  activeIndicator: {
    position: 'absolute',
    right: '14px',
    width: '5px',
    height: '5px',
    borderRadius: '50%',
    background: '#e30504',
    boxShadow: '0 0 10px #459bf2',
  },

  // =========================================================
  // ☀️ MAIN PANEL MODULE - CONVERTED TO LUXURIOUS LIGHT UI
  // =========================================================
  mainWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    overflowX: 'auto',
    height: '100vh', /* 💻 FIXED: Locks the main panel shell viewport height */
    maxHeight: '100vh',
    overflow: 'hidden', /* Keeps header frozen at top */
  },
  headerBar: {
    height: '70px', 
    background: 'rgba(255, 255, 255, 0.85)', /* Light Translucent Glass Header */
    borderBottom: '1px solid #e2e8f0',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px',
    position: 'sticky',
    top: 0,
    zIndex: 90,
    boxSizing: 'border-box',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  hamburgerBtn: {
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    width: '38px',
    height: '38px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#e30504',
    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
  },
  appName: {
    color: '#0f172a', /* Light UI Dark Text color */
    fontSize: '18px',
    fontWeight: '600',
    letterSpacing: '-0.3px',
  },
  profileContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '5px 12px',
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '100px',
    cursor: 'pointer',
    position: 'relative',
    userSelect: 'none',
    boxShadow: '0 2px 4px rgba(0,0,0,0.02)',
  },
  avatarBox: {
    width: '26px',
    height: '26px',
    background: 'rgba(69, 155, 242, 0.08)',
    border: '1px solid rgba(69, 155, 242, 0.15)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  profileMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  userName: {
    color: '#334155',
    fontSize: '13px',
    fontWeight: '500',
  },
  dropdownMenu: {
    position: 'absolute',
    top: '44px',
    right: 0,
    width: '190px',
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '14px',
    padding: '10px 6px',
    boxShadow: '0 10px 25px rgba(15, 23, 42, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  dropdownHeader: {
    padding: '6px 10px',
  },
  dpName: {
    color: '#0f172a',
    fontSize: '13.5px',
    fontWeight: '600',
    margin: 0,
  },
  dpRole: {
    color: '#64748b',
    fontSize: '11px',
    margin: '2px 0 0 0',
  },
  divider: {
    border: 'none',
    borderTop: '1px solid #e2e8f0',
    margin: '4px 0 6px 0',
  },
  dropdownItem: {
    background: 'transparent',
    border: 'none',
    width: '100%',
    padding: '9px 10px',
    borderRadius: '8px',
    color: '#475569',
    fontSize: '13px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    textAlign: 'left',
  },
  contentDock: {
    flex: 1,
    padding: '24px',
    background: '#f8fafc', /* Premium soft clean background content workspace */
    overflowY: 'auto',
    boxSizing: 'border-box',
    overflowY: 'auto',
    overflowX: 'auto',
    height: 'calc(100vh - 70px)',
  },
  viewCard: {
    background: '#ffffff', /* Pure stark light container dashboard paper view */
    border: '1px solid #e2e8f0',
    borderRadius: '16px',
    padding: '24px',
    
    minHeight: '65vh',
    minHeight: 'fit-content',
    boxShadow: '0 4px 20px rgba(15, 23, 42, 0.02)',
    boxSizing: 'border-box',
  },
  moduleTitle: {
    color: '#0f172a',
    fontSize: '22px',
    fontWeight: '600',
    margin: '0 0 12px 0',
  },
  modulePlaceholder: {
    color: '#64748b',
    fontSize: '14px',
    lineHeight: '1.6',
    margin: 0,
  },
};

